/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'goal-fields.goal-followers.add-followers-title': '新增追蹤者',
  'goal-fields.goal-followers.title': '追蹤者',
  'goal-fields.goal-links.add-parent-goal-title': '新增父系目標',
  'goal-fields.goal-links.edit-parent-goal-title': '編輯父系目標',
  'goal-fields.goal-links.unlink-parent-goal-title': '取消連結父系目標',
  'goal-fields.goal-metrics.automatic-metric-title': '從子目標',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.remove-label': '移除',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.settings-label': '設定',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.show-more': '顯示較多',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.update-value-label': '更新值',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': '開始：',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': '目標：',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    '進度會透過 {compass} 自動填入。此目標指標只能在 {compass} 中編輯。',
  'goal-fields.goal-metrics.no-metrics-instructions': '前往完整的目標頁面，以變更此欄位',
  'goal-fields.goal-metrics.no-metrics-title': '沒有指標',
  'goal-fields.goal-metrics.open-in-new-window-label': '在新視窗中開啟',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': '所完成的進度',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': '沒有連接指標的子目標',
  'goal-fields.goal-metrics.title': '進度',
  'goal-fields.goal-owner.title': '負責人',
  'goal-fields.goal-start-date.add-start-date-title': '新增開始日期',
  'goal-fields.goal-start-date.cancel-button': '儲存',
  'goal-fields.goal-start-date.creation-date': '此目標建立於 {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': '編輯目標開始日期',
  'goal-fields.goal-start-date.enter-start-date-title': '輸入開始日期',
  'goal-fields.goal-start-date.open-calendar-label': '開啟行事曆',
  'goal-fields.goal-start-date.title': '開始日期',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': '進行中',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': '更多狀態',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': '目前的狀態是什麼？',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    '要實踐目標與關鍵成果嗎？<link>了解如何將目標用於目標與關鍵成果 (OKR)</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': '說明連結',
  'goal-fields.goal-status.archived': '已封存',
  'goal-fields.goal-status.at-risk': '存在風險',
  'goal-fields.goal-status.cancelled': '已取消',
  'goal-fields.goal-status.completed': '已完成 🎉',
  'goal-fields.goal-status.off-track': '偏離正軌',
  'goal-fields.goal-status.on-track': '進度良好',
  'goal-fields.goal-status.paused': '已暫停',
  'goal-fields.goal-status.pending': '擱置中',
  'goal-fields.goal-status.title': '狀態',
  'goal-fields.goal-sub-goals.add-sub-goals-title': '新增子目標',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': '取消連結子目標',
  'goal-fields.goal-tags.add-tags-title': '新增標記',
  'goal-fields.goal-tags.title': '標記',
  'goal-fields.goal-target-date.picker-placeholder': '擱置中',
  'goal-fields.goal-target-date.title': '目標日期',
  'goal-fields.goal-type.goal': '目標',
  'goal-fields.goal-type.key-result': '關鍵成果',
  'goal-fields.goal-type.objective': 'OKR 目標',
  'goal-fields.goal-type.title': '類型',
  'goal-fields.parent-goal.title': '父系目標',
  'goal-fields.sub-goals.title': '子目標',
  'goal-fields.teams.add-teams-title': '新增團隊',
  'goal-fields.teams.follow-team': '追蹤團隊',
  'goal-fields.teams.remove-team': '移除團隊',
  'goal-fields.teams.search-team-placeholder': '搜尋團隊',
  'goal-fields.teams.show-more': '顯示較多',
  'goal-fields.teams.title': '團隊',
  'goal-fields.teams.verified-team-label': '經過驗證的團隊',
  'goal-fields.teams.view-profile': '檢視設定檔',
  'goal-fields.use-goal-flags.generic-error-description': '發生錯誤，請在幾分鐘後再試一次。',
  'goal-fields.use-goal-flags.generic-error-title': '發生錯誤',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': '無法變更目標負責人',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': '無法新增主題',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': '無法建立主題',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    '您輸入的主題名稱太長。請輸入 255 個字元以下的主題名稱。',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': '無法建立主題',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': '無法移除主題',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title': '新增團隊時發生錯誤，請再試一次',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title': '移除團隊時發生錯誤，請再試一次',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': '無法變更父系目標',
  'goal-fields.use-goal-flags.start-date-change-error-header': '無法變更開始日期',
  'goal-fields.use-goal-flags.target-date-change-error-header': '無法變更目標日期',
  'townsquare.goal-fields.tag': '移除標記',
  'townsquare.goal-fields.tooltip-usage-count': '{usageCount, plural, other {已在 {usageCount,number} 地方使用}}',
};
